import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Customer } from '../../../../_shared/model';
import { CustomerDetailsComponent } from '../customer-details/customer-details.component';

@Component({
    selector: 'app-customer-form',
    templateUrl: './customer-form.component.html',
    styleUrls: ['customer-form.component.scss'],
})
export class CustomerFormComponent {
    @Input()
    customer: Customer;
    @Input()
    newCustomer = false;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onCancelCustomerEditForm: EventEmitter<boolean>;
    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onSaveCustomer: EventEmitter<Customer>;
    @ViewChild('customerDetails', { static: true })
    custDetails: CustomerDetailsComponent;

    constructor() {
        this.onCancelCustomerEditForm = new EventEmitter();
        this.onSaveCustomer = new EventEmitter();
    }

    public cancelCustomerEdit(): void {
        this.onCancelCustomerEditForm.emit(false);
    }

    public saveCustomer(forceSave: boolean): void {
        if (this.newCustomer) {
            this.custDetails.onSubmitNewCustomer(forceSave).subscribe(res => {
                if (res) {
                    this.onSaveCustomer.emit(res);
                }
            });
        } else {
            this.custDetails.onSubmitUpdateCustomerDetails().subscribe((res: Customer) => {
                this.onSaveCustomer.emit(res);
            });
        }
    }
}
